import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import { withStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import { textToSnakeCase } from './../../utils/utils';

const StyledTab = withStyles({
  root: {
    minHeight: 'auto',
    padding: 5,
  },
  wrapper: {
    alignItems: 'flex-start',
  },
})(Tab);

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

interface VerticalTabsMenuEquipmentAssignedInterface {
  value: any;
  setValue: any;
  defaultName: any;
  profiles?: any[];
  hasDefault?: boolean;
}

export default function VerticalTabsMenuEquipmentAssigned({
  value,
  setValue,
  defaultName,
  profiles = [],
  hasDefault = false,
}: VerticalTabsMenuEquipmentAssignedInterface) {
  const { t } = useTranslation();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const classes = useStyles();
  return (
    <Tabs
      orientation="vertical"
      variant="scrollable"
      value={value}
      onChange={handleChange}
      aria-label="Vertical tabs"
      className={classes.tabs}
      scrollButtons="off"
    >
      {profiles.map((profile: any, index) => (
        <StyledTab
          key={`Tab_Styled_${index}`}
          label={`(${
            t(
              `equipment.categories.${textToSnakeCase(profile.category?.name)}`,
              profile.category.name,
            ) || ''
          },
          ${profile?.manufacturer.name || ''})`}
          className={value === index ? classes.tabSelected : classes.tab}
          {...a11yProps(value)}
        />
      ))}
      {hasDefault && (
        <StyledTab
          label={defaultName}
          className={
            value === profiles.length ? classes.tabSelected : classes.tab
          }
          {...a11yProps(profiles.length)}
        />
      )}
    </Tabs>
  );
}
